import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { Injectable, Optional, NgModule, Component, Input, defineInjectable, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/platform-browser';
import * as ɵngcc3 from '@angular/common';

function NgScormPlayerComponent_div_0_iframe_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "iframe", 3);
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r1.urlLaunchPageSafe, ɵngcc0.ɵɵsanitizeResourceUrl);
} }
function NgScormPlayerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, NgScormPlayerComponent_div_0_iframe_1_Template, 1, 1, "iframe", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.openInNewWindow);
} }
var NgScormPlayerConfig = /** @class */ (function () {
    function NgScormPlayerConfig() {
    }
    return NgScormPlayerConfig;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScormResult = /** @class */ (function () {
    function ScormResult() {
    }
    return ScormResult;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgScormPlayerService = /** @class */ (function () {
    function NgScormPlayerService(config, http) {
        this.http = http;
        this.closeWindowOnFinish = false;
        this.errorLogs = [];
        this.openInNewWindow = false;
        // Events
        this.initializeSource = new Subject();
        this.initializeEvent = this.initializeSource.asObservable();
        this.setValueSource = new Subject();
        this.setValueEvent = this.setValueSource.asObservable();
        this.getValueSource = new Subject();
        this.getValueEvent = this.getValueSource.asObservable();
        this.finishSource = new Subject();
        this.finishEvent = this.finishSource.asObservable();
        this.commitSource = new Subject();
        this.commitEvent = this.commitSource.asObservable();
        if (config) {
            this.debug = config.debug;
            this.openInNewWindow = config.openInNewWindow;
        }
    }
    // HELPERS
    /**
     * read the manifest and get the url launch page
     * @param urlDirSco url of the directory of the scorm
     */
    // HELPERS
    /**
     * read the manifest and get the url launch page
     * @param {?} urlDirSco url of the directory of the scorm
     * @return {?}
     */
    NgScormPlayerService.prototype.getUrlLaunchPage = 
    // HELPERS
    /**
     * read the manifest and get the url launch page
     * @param {?} urlDirSco url of the directory of the scorm
     * @return {?}
     */
    function (urlDirSco) {
        /** @type {?} */
        var url = urlDirSco + "/imsmanifest.xml";
        return this.http.get(url, { responseType: 'text' }).pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            /** @type {?} */
            var launchUrl = '';
            /** @type {?} */
            var parser = new DOMParser();
            /** @type {?} */
            var doc = parser.parseFromString(res, 'text/xml');
            /** @type {?} */
            var resources = doc.getElementsByTagName('resource');
            /** @type {?} */
            var filename = resources[0].getAttribute('href');
            launchUrl = urlDirSco + "/" + filename;
            return launchUrl;
        })));
    };
    // SCORM 2004
    // SCORM 2004
    /**
     * @return {?}
     */
    NgScormPlayerService.prototype.Initialize = 
    // SCORM 2004
    /**
     * @return {?}
     */
    function () {
        return this.MyInitialize();
    };
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    NgScormPlayerService.prototype.SetValue = /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        return this.MySetValue(key, value);
    };
    /**
     * @param {?} key
     * @return {?}
     */
    NgScormPlayerService.prototype.GetValue = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return this.MyGetValue(key);
    };
    /**
     * @return {?}
     */
    NgScormPlayerService.prototype.Terminate = /**
     * @return {?}
     */
    function () {
        return this.MyFinish(); // return false to avoid refreh in some  cases
    };
    /**
     * @return {?}
     */
    NgScormPlayerService.prototype.Commit = /**
     * @return {?}
     */
    function () {
        return this.MyCommit();
    };
    /**
     * @return {?}
     */
    NgScormPlayerService.prototype.GetLastError = /**
     * @return {?}
     */
    function () {
        return this.MyGetLastError();
    };
    /**
     * @param {?} errorCode
     * @return {?}
     */
    NgScormPlayerService.prototype.GetErrorString = /**
     * @param {?} errorCode
     * @return {?}
     */
    function (errorCode) {
        return this.MyGetErrorString(errorCode);
    };
    /**
     * @param {?} errorCode
     * @return {?}
     */
    NgScormPlayerService.prototype.GetDiagnostic = /**
     * @param {?} errorCode
     * @return {?}
     */
    function (errorCode) {
        return this.MyGetDiagnostic(errorCode);
    };
    // SCORM 1.2
    // SCORM 1.2
    /**
     * @return {?}
     */
    NgScormPlayerService.prototype.LMSInitialize = 
    // SCORM 1.2
    /**
     * @return {?}
     */
    function () {
        return this.MyInitialize();
    };
    /**
     * @param {?} data
     * @return {?}
     */
    NgScormPlayerService.prototype.LMSFinish = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.MyFinish(); // return false to avoid refreh in some  cases
    };
    /**
     * @param {?} key
     * @return {?}
     */
    NgScormPlayerService.prototype.LMSGetValue = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return this.MyGetValue(key);
    };
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    NgScormPlayerService.prototype.LMSSetValue = /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        return this.MySetValue(key, value);
    };
    /**
     * @return {?}
     */
    NgScormPlayerService.prototype.LMSCommit = /**
     * @return {?}
     */
    function () {
        return this.MyCommit();
    };
    /**
     * @return {?}
     */
    NgScormPlayerService.prototype.LMSGetLastError = /**
     * @return {?}
     */
    function () {
        return this.MyGetLastError();
    };
    /**
     * @param {?} errorCode
     * @return {?}
     */
    NgScormPlayerService.prototype.LMSGetErrorString = /**
     * @param {?} errorCode
     * @return {?}
     */
    function (errorCode) {
        return this.MyGetErrorString(errorCode);
    };
    /**
     * @param {?} errorCode
     * @return {?}
     */
    NgScormPlayerService.prototype.LMSGetDiagnostic = /**
     * @param {?} errorCode
     * @return {?}
     */
    function (errorCode) {
        return this.MyGetDiagnostic(errorCode);
    };
    // My Method
    // My Method
    /**
     * @return {?}
     */
    NgScormPlayerService.prototype.MyInitialize = 
    // My Method
    /**
     * @return {?}
     */
    function () {
        try {
            if (!this.runtimeData) {
                this.runtimeData = {};
            }
            if (!this.scormResult) {
                this.scormResult = new ScormResult();
            }
            this.initializeSource.next(this.scormResult);
            return true;
        }
        catch (err) {
            this.logErrorCode(3);
            return false;
        }
    };
    /**
     * @return {?}
     */
    NgScormPlayerService.prototype.MyFinish = /**
     * @return {?}
     */
    function () {
        try {
            if (this.runtimeData['cmi.completion_status'] === 'completed') {
                this.scormResult.completedOn = new Date();
            }
            this.scormResult.timeSpent = this.parseDurationString(this.runtimeData['cmi.session_time']);
            // progess mesure is value between 0 and 1
            this.scormResult.progression = this.runtimeData['cmi.progress_measure'] ? this.runtimeData['cmi.progress_measure'] * 100 : null;
            this.scormResult.scorePercent = this.runtimeData['cmi.score.scaled'] ? this.runtimeData['cmi.score.scaled'] * 100 : null;
            this.scormResult.runtimeData = this.runtimeData;
            this.finishSource.next(this.scormResult);
            return true;
        }
        catch (err) {
            this.logErrorCode(5);
            return true;
        }
    };
    /**
     * @param {?} key
     * @return {?}
     */
    NgScormPlayerService.prototype.MyGetValue = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        try {
            this.getValueSource.next(this.scormResult);
            return this.runtimeData[key] ? this.runtimeData[key] : '';
        }
        catch (err) {
            this.logErrorCode(1);
            return '';
        }
    };
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    NgScormPlayerService.prototype.MySetValue = /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        try {
            this.runtimeData[key] = value;
            this.scormResult.runtimeData = this.runtimeData;
            this.setValueSource.next(this.scormResult);
            return value;
        }
        catch (err) {
            this.logErrorCode(2);
            return value;
        }
    };
    /**
     * @return {?}
     */
    NgScormPlayerService.prototype.MyCommit = /**
     * @return {?}
     */
    function () {
        try {
            this.scormResult.timeSpent = this.parseDurationString(this.runtimeData['cmi.session_time']);
            // progess mesure is value between 0 and 1
            this.scormResult.progression = this.runtimeData['cmi.progress_measure'] ? this.runtimeData['cmi.progress_measure'] * 100 : null;
            this.scormResult.scorePercent = this.runtimeData['cmi.score.scaled'] ? this.runtimeData['cmi.score.scaled'] * 100 : null;
            this.scormResult.runtimeData = this.runtimeData;
            this.commitSource.next(this.scormResult);
            return true;
        }
        catch (err) {
            this.logErrorCode(6);
            return false;
        }
    };
    /**
     * @return {?}
     */
    NgScormPlayerService.prototype.MyGetLastError = /**
     * @return {?}
     */
    function () {
        return this.errorLogs.length > 0 ? this.errorLogs[0] : 0;
    };
    /**
     * @param {?} errorCode
     * @return {?}
     */
    NgScormPlayerService.prototype.MyGetErrorString = /**
     * @param {?} errorCode
     * @return {?}
     */
    function (errorCode) {
        /** @type {?} */
        var errorString;
        switch (errorCode) {
            case 0:
                errorString = 'None error';
                break;
            case 1:
                errorString = 'Error to get value';
                break;
            case 2:
                errorString = 'Error to set value';
                break;
            case 3:
                errorString = 'Error to Initialize';
                break;
            case 4:
                errorString = 'Error to save data';
                break;
            case 5:
                errorString = 'Error to Finish';
                break;
            case 6:
                errorString = 'Error to Commit';
                break;
        }
        return errorString;
    };
    /**
     * @param {?} errocCode
     * @return {?}
     */
    NgScormPlayerService.prototype.MyGetDiagnostic = /**
     * @param {?} errocCode
     * @return {?}
     */
    function (errocCode) {
        return 'NO_DIAGNOSTIC';
    };
    // helpers
    // helpers
    /**
     * @private
     * @param {?} msg
     * @return {?}
     */
    NgScormPlayerService.prototype.logErrorCode = 
    // helpers
    /**
     * @private
     * @param {?} msg
     * @return {?}
     */
    function (msg) {
        this.errorLogs.push(msg);
    };
    /**
     * @private
     * @param {?} durationString
     * @return {?}
     */
    NgScormPlayerService.prototype.parseDurationString = /**
     * @private
     * @param {?} durationString
     * @return {?}
     */
    function (durationString) {
        if (!durationString || durationString === '') {
            return 0;
        }
        /** @type {?} */
        var stringPattern = /^PT(?:(\d+)D)?(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d{1,3})?)S)?$/;
        /** @type {?} */
        var stringParts = stringPattern.exec(durationString);
        return ((((stringParts[1] === undefined ? 0 : Number(stringParts[1])) /* Days */
            * 24 + (stringParts[2] === undefined ? 0 : Number(stringParts[2])) /* Hours */)
            * 60 + (stringParts[3] === undefined ? 0 : Number(stringParts[3])) /* Minutes */)
            * 60 + (stringParts[4] === undefined ? 0 : Number(stringParts[4])) /* Seconds */);
    };
    /** @nocollapse */
    NgScormPlayerService.ctorParameters = function () { return [
        { type: NgScormPlayerConfig, decorators: [{ type: Optional }] },
        { type: HttpClient }
    ]; };
    /** @nocollapse */ NgScormPlayerService.ngInjectableDef = defineInjectable({ factory: function NgScormPlayerService_Factory() { return new NgScormPlayerService(inject(NgScormPlayerConfig, 8), inject(HttpClient)); }, token: NgScormPlayerService, providedIn: "root" });
NgScormPlayerService.ɵfac = function NgScormPlayerService_Factory(t) { return new (t || NgScormPlayerService)(ɵngcc0.ɵɵinject(NgScormPlayerConfig, 8), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
NgScormPlayerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NgScormPlayerService, factory: function (t) { return NgScormPlayerService.ɵfac(t); }, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgScormPlayerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NgScormPlayerConfig, decorators: [{
                type: Optional
            }] }, { type: ɵngcc1.HttpClient }]; }, null); })();
    return NgScormPlayerService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function _window() {
    // return the global native browser window object
    return window;
}
var WindowRef = /** @class */ (function () {
    function WindowRef() {
    }
    Object.defineProperty(WindowRef.prototype, "nativeWindow", {
        get: /**
         * @return {?}
         */
        function () {
            return _window();
        },
        enumerable: true,
        configurable: true
    });
WindowRef.ɵfac = function WindowRef_Factory(t) { return new (t || WindowRef)(); };
WindowRef.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: WindowRef, factory: function (t) { return WindowRef.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WindowRef, [{
        type: Injectable
    }], function () { return []; }, null); })();
    return WindowRef;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgScormPlayerComponent = /** @class */ (function () {
    function NgScormPlayerComponent(win, playerSco, sanitizer) {
        this.win = win;
        this.playerSco = playerSco;
        this.sanitizer = sanitizer;
        this.openInNewWindow = this.openInNewWindow ? this.openInNewWindow : this.playerSco.openInNewWindow;
    }
    /**
     * @return {?}
     */
    NgScormPlayerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.init();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgScormPlayerComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        this.init();
        if (this.playerSco.debug) {
            console.log('prop changes:', changes);
        }
    };
    /**
     * @return {?}
     */
    NgScormPlayerComponent.prototype.init = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.initializing) {
            return;
        }
        this.initializing = true;
        this.win.nativeWindow.API_1484_11 = this.playerSco;
        this.win.nativeWindow.API = this.playerSco;
        // try to set the api directly in the frame window
        try {
            /** @type {?} */
            var frame = document.getElementById("scoIframe");
            frame['contentWindow'].API_1484_11 = this.playerSco;
            frame['contentWindow'].API = this.playerSco;
        }
        catch (err) {
            if (this.playerSco.debug) {
                console.log('error settings api directlty in frame:', err);
            }
        }
        if (!this.urlLaunchPage && this.urlDirSco) {
            this.playerSco.getUrlLaunchPage(this.urlDirSco).subscribe((/**
             * @param {?} url
             * @return {?}
             */
            function (url) {
                _this.urlLaunchPageSafe = _this.sanitizer.bypassSecurityTrustResourceUrl(url);
                _this.maybeOpenWindow(url);
                _this.initializing = false;
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                if (_this.playerSco.debug) {
                    console.log('error finding urlLaunchPage', err);
                }
                _this.initializing = false;
            }));
        }
        else if (this.urlLaunchPage) {
            this.urlLaunchPageSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlLaunchPage);
            this.maybeOpenWindow(this.urlLaunchPage);
            this.initializing = false;
        }
        else {
            if (this.playerSco.debug) {
                console.error('no url provided');
            }
            this.initializing = false;
        }
    };
    /**
     * @param {?} url
     * @return {?}
     */
    NgScormPlayerComponent.prototype.maybeOpenWindow = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        if (this.openInNewWindow) {
            this.win.nativeWindow.open(url, '_blank');
        }
    };
    /** @nocollapse */
    NgScormPlayerComponent.ctorParameters = function () { return [
        { type: WindowRef },
        { type: NgScormPlayerService },
        { type: DomSanitizer }
    ]; };
    NgScormPlayerComponent.propDecorators = {
        urlDirSco: [{ type: Input }],
        urlLaunchPage: [{ type: Input }],
        scormResult: [{ type: Input }],
        openInNewWindow: [{ type: Input }]
    };
NgScormPlayerComponent.ɵfac = function NgScormPlayerComponent_Factory(t) { return new (t || NgScormPlayerComponent)(ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(NgScormPlayerService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DomSanitizer)); };
NgScormPlayerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgScormPlayerComponent, selectors: [["ng-scorm-player"]], inputs: { openInNewWindow: "openInNewWindow", urlDirSco: "urlDirSco", urlLaunchPage: "urlLaunchPage", scormResult: "scormResult" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "container", 4, "ngIf"], [1, "container"], ["class", "no-border", "sandbox", "allow-scripts allow-forms allow-same-origin allow-modals allow-top-navigation allow-popups", "name", "scoIframe", "id", "scoIframe", "width", "100%", "height", "100%", 3, "src", 4, "ngIf"], ["sandbox", "allow-scripts allow-forms allow-same-origin allow-modals allow-top-navigation allow-popups", "name", "scoIframe", "id", "scoIframe", "width", "100%", "height", "100%", 1, "no-border", 3, "src"]], template: function NgScormPlayerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgScormPlayerComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.urlLaunchPageSafe);
    } }, directives: [ɵngcc3.NgIf], styles: [".container[_ngcontent-%COMP%]{height:100%;width:100%}.no-border[_ngcontent-%COMP%]{border:none!important}"] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgScormPlayerComponent, [{
        type: Component,
        args: [{
                selector: 'ng-scorm-player',
                template: "<div class=\"container\" *ngIf=\"urlLaunchPageSafe\">\n  <iframe *ngIf=\"!openInNewWindow\"\n  class=\"no-border\" \n  sandbox=\"allow-scripts allow-forms allow-same-origin allow-modals allow-top-navigation allow-popups\" \n  [src]=\"urlLaunchPageSafe\" \n  name=\"scoIframe\" \n  id=\"scoIframe\" \n  width=\"100%\" \n  height=\"100%\" >    \n  </iframe>\n</div>\n\n\n",
                styles: [".container{height:100%;width:100%}.no-border{border:none!important}"]
            }]
    }], function () { return [{ type: WindowRef }, { type: NgScormPlayerService }, { type: ɵngcc2.DomSanitizer }]; }, { openInNewWindow: [{
            type: Input
        }], urlDirSco: [{
            type: Input
        }], urlLaunchPage: [{
            type: Input
        }], scormResult: [{
            type: Input
        }] }); })();
    return NgScormPlayerComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgScormPlayerModule = /** @class */ (function () {
    function NgScormPlayerModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    NgScormPlayerModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: NgScormPlayerModule,
            providers: [
                { provide: NgScormPlayerConfig, useValue: config }
            ]
        };
    };
    /**
     * @param {?} config
     * @return {?}
     */
    NgScormPlayerModule.forChild = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: NgScormPlayerModule,
            providers: [
                { provide: NgScormPlayerConfig, useValue: config }
            ],
        };
    };
NgScormPlayerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgScormPlayerModule });
NgScormPlayerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgScormPlayerModule_Factory(t) { return new (t || NgScormPlayerModule)(); }, providers: [
        WindowRef
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgScormPlayerModule, { declarations: function () { return [NgScormPlayerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgScormPlayerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgScormPlayerModule, [{
        type: NgModule,
        args: [{
                declarations: [NgScormPlayerComponent],
                imports: [
                    CommonModule
                ],
                exports: [
                    NgScormPlayerComponent
                ],
                providers: [
                    WindowRef
                ]
            }]
    }], function () { return []; }, null); })();
    return NgScormPlayerModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgScormPlayerConfig, ScormResult, NgScormPlayerService, NgScormPlayerComponent, NgScormPlayerModule, WindowRef as ɵa };

//# sourceMappingURL=ng-scorm-player.js.map